import { AscDesc as r } from "../AscDesc/AscDesc.js";
import { PagingLimit as i } from "../PagingLimit/PagingLimit.js";
import { OrderBy as a } from "../OrderBy/OrderBy.js";
import { Paging as n } from "../Paging/Paging.js";
import '../assets/SearchFilterResults.css';const l = "op_searchFilterRightSettingsHolder_nHtE6", c = "op_searchFilterHolder_vd-ow", t = {
  searchFilterRightSettingsHolder: l,
  searchFilterHolder: c
};
function g(e) {
  return /* @__PURE__ */ React.createElement("div", { className: t.searchFilterHolder }, /* @__PURE__ */ React.createElement(
    n,
    {
      resultCount: e.resultsCount,
      page: e.page,
      limit: e.limit,
      onClick: e.onChange
    }
  ), /* @__PURE__ */ React.createElement("details", null, /* @__PURE__ */ React.createElement("summary", null, "Change search result presentation settings"), /* @__PURE__ */ React.createElement("div", { className: t.searchFilterRightSettingsHolder }, /* @__PURE__ */ React.createElement(a, { orderByInputAttributes: { options: e.orderResultsByChoices, onChange: e.onChange, value: e.order_by } }), /* @__PURE__ */ React.createElement(r, { value: e.order, inputAttri: { onChange: e.onChange } }), /* @__PURE__ */ React.createElement(i, { limitInputAttributes: { value: e.limit, onChange: e.onChange, showLimit: e.showLimit } }))));
}
export {
  g as SearchFilterResults
};
